// Form control

const submitBtn = document.querySelector(".js-launch-control"),
      fields = document.querySelectorAll(".js-required");

let hasError = false;

submitBtn.addEventListener("click", () => {
  hasError = false;

  fields.forEach((field) => {
    checkFields(field);
  });

  if (!hasError) {
    submitBtn.textContent = 'Envoi en cours…';

    submitBtn.addEventListener('click', (e) => {
      e.preventDefault();
    });
  }
});

fields.forEach((field) => {
  const inputs = field.querySelectorAll("[required='required']");

  inputs.forEach((input) => {
    input.addEventListener("input", () => {
      checkFields(field);
    });
  });

});

window.addEventListener("load", () => {
  const select2Entities = document.querySelectorAll(".select2-selection");

  select2Entities.forEach((select2Entity) => {
    const parent = select2Entity.closest(".js-required"),
          selectRendered = select2Entity.querySelector(".select2-selection__rendered");

    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function() {
        checkFields(parent);
      });
    });
    var config = { attributes: true };
    observer.observe(selectRendered, config);
  });

});

function checkFields(field) {
    const value = field.querySelector("[required='required']").value,
      formGroup = field;
    let format;
    if(field.dataset.format) {
      format = field.dataset.format;
    }
    if (value) {
      // Si le champ n'est pas vide
      if(format) {
        if (format === 'onlyNumbers') {
          // Si une exigence de format en nombre est donnée
          if (!isNaN(value)) {
            if (value.length === Number(field.dataset.length)) {
              // Si une exigence en nombre de caractères est donnée
              if (formGroup.classList.contains('has-error')) {
                formGroup.classList.remove('has-error')
              }
            } else {
              formGroup.classList.add('has-error');
              hasError = true;
            }
          } else {
            formGroup.classList.add('has-error');
            hasError = true;
          }
        } else if (format === 'isEmail') {
          if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
            if (formGroup.classList.contains('has-error')) {
              formGroup.classList.remove('has-error')
            }
          } else {
            formGroup.classList.add('has-error');
            hasError = true;
          }
        } else if (format === 'isCheckbox') {
          const checkbox = field.querySelector("[type='checkbox']");
          if(checkbox.checked) {
            if (formGroup.classList.contains('has-error')) {
              formGroup.classList.remove('has-error')
            }
          } else {
            formGroup.classList.add('has-error');
            hasError = true;
          }
        } else if (format === 'isRadio') {
          const inputsRadios =  field.querySelectorAll("[type='radio']");
          let flag = false;
          new Promise(resolve => {
            inputsRadios.forEach((radio) => {
              radio.checked ? flag = true : null;
            });
            resolve();
          }).then(() => {
            if(flag === true) {
              if (formGroup.classList.contains('has-error')) {
                formGroup.classList.remove('has-error')
              }
            } else {
              formGroup.classList.add('has-error');
              hasError = true;
            }
          });
        } else if (format === 'isSelect'){
          if(value !== "") {
            if (formGroup.classList.contains('has-error')) {
              formGroup.classList.remove('has-error')
            }
          } else {
            formGroup.classList.add('has-error');
            hasError = true;
          }
        }
      } else {
        if (formGroup.classList.contains('has-error')) {
          formGroup.classList.remove('has-error')
        }
      }
    } else {
      formGroup.classList.add('has-error');
      hasError = true;
    }
}
